import { translateBackend } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';
import type { SxProps, Theme } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import InfoDialog from '@ovComponents/2-component/infoDialog/infoDialog';
import { useThemeTokens } from '@providers/themeTokenProvider';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type DisclaimerOptions = {
  contentDescriptionBanner: TranslatedString;
  contentDescriptionTitle: TranslatedString;
  contentDescription: TranslatedString;
};

export default function Disclaimer({
  options,
  sx,
}: {
  options: DisclaimerOptions;
  sx?: SxProps<Theme>;
}) {
  const { sys } = useThemeTokens();

  if (
    !options?.contentDescriptionBanner &&
    !options?.contentDescriptionTitle &&
    !options?.contentDescription
  )
    return <></>;

  return (
    <Box
      pb={2}
      mb={2}
      display='flex'
      justifyContent='center'
      alignItems='center'
      position='relative'
      sx={sx}
    >
      <Box display='flex' alignItems='center' justifyContent='center'>
        <Typography variant='bodyMedium'>
          <ReactMarkdown
            className='markdown'
            remarkPlugins={[remarkGfm]}
            linkTarget='_blank'
          >
            {translateBackend(options.contentDescriptionBanner)}
          </ReactMarkdown>
        </Typography>
        <InfoDialog
          title={translateBackend(options.contentDescriptionTitle)}
          information={translateBackend(options.contentDescription)}
          dialogSx={{
            '.MuiDialog-container': {
              alignItems: 'flex-start',
              paddingTop: 2,
              '.MuiDialogTitle-root': { border: 'none' },
              '.MuiDialogContent-root': {
                paddingTop: '0px !important',
                '.MuiTypography-root': { m: 0, pb: 2 },
              },
            },
          }}
          center
        />
      </Box>
      <Box
        sx={{
          borderBottom: `2px solid ${sys.color.neutralPressed}`,
          position: 'absolute',
          bottom: 0,
          left: { xs: -16, sm: -32 },
          right: { xs: -16, sm: -32 },
          zIndex: 1000,
        }}
      />
    </Box>
  );
}
